import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  //integrations: [Sentry.browserTracingIntegration()],
  //tracePropagationTargets: [/^\//, /^https:\/\/app\.grapegraph\.ai\/api/, /^https:\/\/grapegraph\.ai/],
  //tracesSampleRate: 1.0, // Capture 100% of transactions, lower in production
  sendDefaultPii: true
});

export default Sentry;
